module.exports = __webpack_public_path__ + "static/media/599.7054(1).57a5b2a0.pdf";